// Laenderflagge aus dem eigenen public/flags-Verzeichnis.
//
// Ersetzt react-country-flag: das Paket laedt seine SVGs von cdn.jsdelivr.net
// und schickt damit die IP jedes Besuchers an ein fremdes CDN, bevor irgendeine
// Einwilligung vorliegt. Die Emoji-Variante (svg={false}) scheidet aus, weil
// Windows die Regional-Indicator-Paare als blosse Buchstaben ("DE") darstellt.
//
// Die benoetigten Flaggen liegen als SVG unter /flags/<code>.svg (Quelle:
// lipis/flag-icons, 4x3, einmalig heruntergeladen).
const CountryFlag = ({ countryCode, alt = "", title, style, className }) => {
  if (!countryCode) return null;

  return (
    <img
      src={`/flags/${countryCode.toLowerCase()}.svg`}
      alt={alt}
      title={title}
      loading="lazy"
      decoding="async"
      style={style}
      className={className}
      aria-hidden={alt ? undefined : true}
    />
  );
};

export default CountryFlag;
